module.exports = __webpack_public_path__ + "static/assets/60204ab35b0cbf8cb85977e1fd707b05.png";